import type { FormKitNode } from '@formkit/core'
import { rootClasses as baseRootClasses } from './formkit.theme'

const globalOverrides: Record<string, string> = {
  'selection:bg-blue-100': 'selection:bg-blue2-light',
  'selection:text-neutral-700': 'selection:text-gray',
  'ring-blue-500': 'ring-blue2',
  'border-neutral-400': 'border-gray-lighter',
  'bg-neutral-400': 'bg-gray-lighter',
  'bg-neutral-50': 'bg-white',
  'text-neutral-700': 'text-gray-dark',
  'text-red-600': 'text-red',
  'max-w-[20em]': '',
  'peer-checked:bg-blue-600': 'peer-checked:bg-blue2',
  'peer-focus-visible:ring-blue-500': ' peer-focus-visible:ring-blue2'
}

const additions: Partial<Record<string, Partial<Record<string, boolean>>>> = {
  text__label: {
    'font-outline': true
  },
  form__message: {
    'text-center': true
  }
}

export function rootClasses(sectionName: string, node: FormKitNode): Record<string, boolean> {
  const key = `${node.props.type}__${sectionName}`
  const base = baseRootClasses(sectionName, node)

  const overridden: Record<string, boolean> = {}
  for (const [className, _] of Object.entries(base)) {
    overridden[globalOverrides[className] ?? className] = true
  }

  Object.assign(overridden, additions[key])
  return overridden
}
